import React from 'react'

function SortOrder(props) {
  const { sortByorder, statusType, sortOrderReset, changeSortOrderBy } = props
  return (
    <div className='agerestriction'>
      <label>Sort Order</label>
      <div className='d-flex'>
        <select
          disabled={statusType === 'draft'}
          defaultValue={'desc'}
          value={sortByorder}
          onChange={e => changeSortOrderBy(e)}
          required
          name='select'
          id='languages'
        >
          <option value='' disabled selected>
            Sort Order
          </option>
          <option value='desc' selected={sortByorder === 'desc'}>
            Latest
          </option>
          <option value='asc' selected={sortByorder === 'asc'}>
            old
          </option>
        </select>
        <button
          style={{ padding: '1px 7px', marginLeft: '4px' }}
          onClick={sortOrderReset}
          className='btn btn-primary'
        >
          x
        </button>
      </div>
    </div>
  )
}

export default SortOrder
